<br />
<br />

<div class="row w-100 mt-5 mx-0 justify-content-center mt-5">
  <div class="col-12 col-md-7 col-lg-8 my-auto px-5 order-md-1 order-2">
    <div class="title">
      {{ "Career Coach" | translate }}
    </div>
    <div class="description">
      {{
        "We help take your career to the next level with professional career coaching"
          | translate
      }}
    </div>
    <a href="https://wa.me/+201555842727" target="_blank">
      <button class="gradient-button">
        {{ "Schedule with your coach" | translate }}
      </button>
    </a>
  </div>
  <img
    class="col-6 col-md-5 col-lg-4 order-md-2 order-1"
    src="../../../assets/img/career coatch.png"
  />
</div>

<div class="m-5">
  <div class="title">
    {{ "Positive behavioral supports is a behavior management" | translate }}
  </div>
  <div class="row">
    <div class="col-12 col-sm-6 col-md-4">
      {{
        "Up-Career is everything you need to grow in your online career"
          | translate
      }}
    </div>

    <app-card
      *ngFor="let item of services"
      [color]="item.color"
      [img]="item.img"
      [title]="item.title"
      [description]="item.description"
    />
  </div>
</div>
<app-certificates></app-certificates>
<app-pricing></app-pricing>
<!-- <app-content-dialog></app-content-dialog> -->
